import { render, staticRenderFns } from "./OrderEqualRecordDetail.vue?vue&type=template&id=84fe9120&scoped=true"
import script from "./OrderEqualRecordDetail.vue?vue&type=script&lang=js"
export * from "./OrderEqualRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderEqualRecordDetail.vue?vue&type=style&index=0&id=84fe9120&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fe9120",
  null
  
)

export default component.exports